import { FC, useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Chip,
  SxProps,
} from '@mui/material';
import { useSearch, SEARCH_PARAM_BENEFITS } from '@carcareers/contexts';
import { BENEFITS } from '@carcareers/utils';

interface JobSearchBenefitsInputProps {
  sx?: SxProps;
}

export const JobSearchBenefitsInput: FC<JobSearchBenefitsInputProps> = ({ sx }) => {
  const { benefits: benefitsContext, updateSearchParams } = useSearch();
  
  const [selectedBenefits, setSelectedBenefits] = useState<string[]>(
    benefitsContext ? benefitsContext.split(',') : []
  );

  const handleBenefitToggle = (benefit: string) => () => {
    let newSelectedBenefits: string[];
    
    if (selectedBenefits.includes(benefit)) {
      newSelectedBenefits = selectedBenefits.filter(item => item !== benefit);
    } else {
      newSelectedBenefits = [...selectedBenefits, benefit];
    }
    
    setSelectedBenefits(newSelectedBenefits);
    updateSearchParams(
      SEARCH_PARAM_BENEFITS, 
      newSelectedBenefits.length > 0 ? newSelectedBenefits.join(',') : undefined
    );
  };

  useEffect(() => {
    const contextBenefits = benefitsContext ? benefitsContext.split(',') : [];
    if (JSON.stringify(contextBenefits) !== JSON.stringify(selectedBenefits)) {
      setSelectedBenefits(contextBenefits);
    }
  }, [benefitsContext]);

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Typography variant="h6" gutterBottom>Benefits</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {BENEFITS.map((benefit) => (
          <Chip
            key={benefit.value}
            label={benefit.name}
            onClick={handleBenefitToggle(benefit.value)}
            color={selectedBenefits.includes(benefit.value) ? 'primary' : 'default'}
            variant={selectedBenefits.includes(benefit.value) ? 'filled' : 'outlined'}
            sx={{ mb: 1 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default JobSearchBenefitsInput;
